import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import {
  Button,
  DialogContent,
  DialogContentText,
  Grid,
  TableCell,
  TableRow,
  TextField,
  Radio,
  TablePagination,
} from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import { useDispatch, useSelector } from "react-redux";
import {
  getLeadCustomerAction,
  setNewLeadLocal,
} from "../../../../store/reducers/leadSlice";
import dayjs from "dayjs";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";

interface LeadCustomerListProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  setAlertModelShow?: any;
  setCountryCode?: any;
}

const LeadCustomerList: React.FC<LeadCustomerListProps> = ({
  open,
  title,
  onHide = () => {},
  setAlertModelShow,
  setCountryCode,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingClose, setPendingClose] = useState(false);

  const tableHeadings: TableHeading[] = [
    { label: "Name", align: "left" },
    { label: "Added", align: "center" },
    { label: "Lead Mod", align: "center" },
    { label: "Lead QTY", align: "center" },
    { label: "Select", align: "center" },
  ];

  const { leadCustomers, newLeadLocal } = useSelector(
    (state: any) => state.lead,
  );

  const { userProfile } = useSelector((state: any) => state.user);

  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const applyCustomerToForm = () => {
    if (selectedCustomer) {
       const extractedCountryCode =
        selectedCustomer?.customer_phone?.match(/^\+91|\+44/);
      setCountryCode(extractedCountryCode ? extractedCountryCode[0] : "+44");
      const collections =
        selectedCustomer?.collection_addresses?.map((addr: any) => ({
          building_number: addr.building_number || "",
          street: addr.street || "",
          town: addr.town || "",
          county: addr.county || "",
          postcode: addr.postcode || "",
          country: addr.country || "",
          distance: addr.distance || "",
          address_type: "COLLECTION",
        })) || [];

      const deliveries =
        selectedCustomer?.delivery_addresses?.map((addr: any) => ({
          building_number: addr.building_number || "",
          street: addr.street || "",
          town: addr.town || "",
          county: addr.county || "",
          postcode: addr.postcode || "",
          country: addr.country || "",
          distance: addr.distance || "",
          address_type: "DELIVERY",
        })) || [];

    
      dispatch(
        setNewLeadLocal({
          ...newLeadLocal,
          referrerId: selectedCustomer.referrer_id,
          customer: {
            name: selectedCustomer.customer_name,
            phone: selectedCustomer.customer_phone ? selectedCustomer.customer_phone.replace(/^(\+91|\+44)/, "") : "" ,
            email: selectedCustomer.customer_email,
            account_name: selectedCustomer.account_name,
            prefix: selectedCustomer.prefix,
          },
          advert_id: selectedCustomer?.advert_id,
          promo_code: selectedCustomer?.promo_code,
          promo_source: selectedCustomer?.promo_source,
          sales_person_id: selectedCustomer?.sales_person_id,
          sales_person_name: selectedCustomer?.sales_person_name,
          lead_type_id: selectedCustomer?.lead_type_id,
          collectionAddress: collections,
          deliveryAddress: deliveries,
        }),
      );

      setShowConfirm(false);
      onHide();
    }
  };

  console.log("LeadCustomerList - newLeadLocal:", newLeadLocal);

  const [filterData, setFilterData] = useState({
    name: newLeadLocal?.customer?.name ?? "",
    phone: newLeadLocal?.customer?.phone ?? "",
    email: newLeadLocal?.customer?.email ?? "",
  });

  /* Pagination */
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  useEffect(() => {
    if (open) {
      dispatch(getLeadCustomerAction(filterData));
    }
  }, [open]);

  const handleSelectCustomer = (customer: any) => {
    setSelectedCustomer(customer);
  };

  const closeModel = () => {
    if (selectedCustomer) {
      setShowConfirm(true);
      setPendingClose(true);
    } else {
      setAlertModelShow(false);
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    setFilterData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    setPage(0);
    dispatch(getLeadCustomerAction(filterData));
  };

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOk = () => {
    if (selectedCustomer) {
      onHide();
    }
  };

  const paginatedCustomers = leadCustomers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <>
      <Popup
        open={open}
        title={title || ""}
        onHide={onHide}
        fullWidth
        maxWidth="md"
        header={
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        }
      >
        <DialogContent sx={{ padding: "6px 8px" }}>
          <DialogContentText>
            {/* Search Section */}
            <Grid container spacing={1} mb={2}>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Name"
                  name="name"
                  value={filterData.name}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                  sx={{ "& .MuiOutlinedInput-root": { height: 32 } }}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Phone"
                  name="phone"
                  value={filterData.phone}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                  sx={{ "& .MuiOutlinedInput-root": { height: 32 } }}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Email"
                  name="email"
                  value={filterData.email}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                  sx={{ "& .MuiOutlinedInput-root": { height: 32 } }}
                />
              </Grid>

              <Grid item xs={3} textAlign="right">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  sx={{
                    height: 32,
                    fontSize: "12px",
                    backgroundColor: "#008E72",
                    "&:hover": { backgroundColor: "#00775f" },
                  }}
                >
                  Search
                </Button>
              </Grid>
            </Grid>

            {/* Table */}
            <TableDesign
              tableHeadings={tableHeadings}
              tableHeadColor={"#008E72"}
              cellColor={"#fff"}
              pagination={null}
              isLoader={false}
              filterOption={() => {}}
              setFilterOption={() => {}}
            >
              {paginatedCustomers.length > 0 ? (
                paginatedCustomers.map((val: any, idx: number) => {
                  const isSelected = selectedCustomer?.lead_id === val.lead_id;

                  return (
                    <TableRow
                      key={idx}
                      onClick={() => handleSelectCustomer(val)}
                      sx={{
                        backgroundColor: idx % 2 === 0 ? "#F9F9F9" : "#FFFFFF",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#E5F4F1" },
                      }}
                    >
                      <TableCell sx={{ padding: "3px 8px", fontSize: 13 }}>
                        {val?.prefix
                          ? `${val.prefix} - ${val.customer_name}`
                          : val?.customer_name}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ padding: "3px 6px", fontSize: 13 }}
                      >
                        {dayjs(val?.lead_created_at).format(
                          userProfile?.dateFormat || "DD/MM/YYYY",
                        )}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ padding: "3px 6px", fontSize: 13 }}
                      >
                        {val?.updated_at
                          ? dayjs(val?.updated_at).format(
                              userProfile?.dateFormat || "DD/MM/YYYY",
                            )
                          : ""}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ padding: "3px 6px", fontSize: 13 }}
                      >
                        {val?.lead_qty}
                      </TableCell>

                      <TableCell align="center" sx={{ padding: "3px 6px" }}>
                        <Radio
                          checked={isSelected}
                          size="small"
                          onChange={() => handleSelectCustomer(val)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeadings.length}>
                    <span
                      style={{
                        textAlign: "center",
                        display: "block",
                        padding: "10px 0",
                      }}
                    >
                      Data Not Found!
                    </span>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>

            {/* Pagination */}
            <TablePagination
              component="div"
              count={leadCustomers.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
              sx={{
                "& .MuiTablePagination-toolbar": {
                  minHeight: "36px",
                },
              }}
            />

            {/* OK Button */}
            {selectedCustomer && (
              <Grid container justifyContent="flex-end" mt={2}>
                <Button
                  variant="contained"
                  onClick={applyCustomerToForm}
                  sx={{
                    height: 32,
                    fontSize: "12px",
                    backgroundColor: "#008E72",
                    "&:hover": { backgroundColor: "#00775f" },
                  }}
                >
                  Apply Customer
                </Button>
              </Grid>
            )}
          </DialogContentText>
        </DialogContent>
      </Popup>
      {showConfirm && (
        <AlertPopup
          open={showConfirm}
          onHide={() => {
            setShowConfirm(false);
          }}
          title="Alert"
          content="You selected a customer. Do you want to close without filling the form?"
          submitHandler={() => {
            setShowConfirm(false);
            onHide();
          }}
        />
      )}
    </>
  );
};

export default LeadCustomerList;
